module.exports = __webpack_public_path__ + "img/113.3.52d20e3e.png";